// ColorModeIconDropdown.tsx
import * as React from 'react';
import DarkModeIcon from '@mui/icons-material/DarkModeRounded';
import LightModeIcon from '@mui/icons-material/LightModeRounded';
import { Box, Menu, MenuItem, Tooltip, Zoom } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { cookies } from '../cookies';
import { useColorScheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

/*
line 104
                <Tooltip title={t("color.picker.dark")}
                         placement="bottom"
                         slots={{
                            transition: Zoom,
                         }}
                         slotProps={{
                            transition: { timeout: 300 },
                         }} arrow>
                    <MenuItem selected={modeUsed === 'dark'} onClick={handleMode('dark')}>
                        { t("color.picker.dark") }
                    </MenuItem>
                </Tooltip>
*/

export default function ColorModeIconDropdown({ mode, systemMode }: { mode: any, systemMode: any }) {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { setMode } = useColorScheme();
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleMode = (targetMode: 'light' | 'dark') => () => {
        setMode(targetMode);
        cookies.set('theme-mode', targetMode, { path: '/' });
        handleClose();
    };
    const modeUsed = cookies.get('theme-mode') || mode;
    if (!modeUsed) {
        return (
            <Box
                data-screenshot="toggle-mode"
                sx={(theme) => ({
                    verticalAlign: 'bottom',
                    display: 'inline-flex',
                    width: '2.25rem',
                    height: '2.25rem',
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    border: '1px solid',
                    borderColor: (theme.vars || theme).palette.divider,
                })}
            />
        );
    }
    const resolvedMode = (systemMode || modeUsed) as 'light' | 'dark';
    const icon = {
        light: <LightModeIcon />,
        dark: <DarkModeIcon />,
    }[resolvedMode];

    return (
        <React.Fragment>
            <Tooltip title={t("color.picker")}
                     placement="bottom"
                     slots={{
                        transition: Zoom,
                     }}
                     slotProps={{
                        transition: { timeout: 300 },
                     }} arrow>
                <IconButton
                    data-screenshot="toggle-mode"
                    onClick={handleClick}
                    disableRipple
                    sx={{
                        width: 50,
                        height: 40
                    }}
                    aria-controls={open ? 'color-scheme-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined} >
                    {icon}
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                id="color-mode-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: {
                        variant: 'outlined',
                        elevation: 0,
                        sx: {
                            my: '4px',
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
                <Tooltip title={t("color.picker.light")}
                         placement="bottom"
                         slots={{
                            transition: Zoom,
                         }}
                         slotProps={{
                            transition: { timeout: 300 },
                         }} arrow>
                    <MenuItem selected={modeUsed === 'light'} onClick={handleMode('light')}>
                        { t("color.picker.light") }
                    </MenuItem>
                </Tooltip>
            </Menu>
       </React.Fragment>
    );
}